<template>
  <div class="container">
    <div class="main">
      <a-form-model :model="form" layout="inline" class="search">
        <a-button
          class="toggle"
          shape="circle"
          @click="visible_search = !visible_search"
          :type="visible_search ? '' : 'primary'"
          :icon="visible_search ? 'up' : 'down'"
        >
        </a-button>
        <div class="hide-search" v-if="!visible_search"></div>
        <a-descriptions bordered size="small" :column="1" v-if="visible_search" style="margin-bottom:12px">
          <a-descriptions-item label="商标分类">
            <div class="description category_description">
              <div class="field ig">
                <a-checkable-tag
                  v-for="item in trademark_data"
                  :key="item.code"
                  class="category_width"
                  style="width:140px;margin-bottom: 4px;cursor: pointer"
                  :checked="internationalGroup_checked.indexOf(item.code) > -1"
                  @change="(e) => on_field_mutli_change(e, 'internationalGroup', item.code)"
                >
                  <div class="iga"
                       :class="data_count_internationalGroup && !item.search_count ? 'empty' : 'fill'">
                                        <span class="code">{{ item.code }}</span
                                        ><span class="name">{{ item.name }}</span>
                    <span class="count search_count" v-if="item.search_count">({{ item.search_count || "" }})</span>
                  </div>
                </a-checkable-tag>
              </div>
              <div class="extra">
                <a-switch
                  checked-children="多选"
                  un-checked-children="单选"
                  @change="(e) => on_search_choice(e, 'internationalGroup')"
                />
              </div>
            </div>
          </a-descriptions-item>

          <a-descriptions-item label="商标子类" v-if="trademark_children.length">
            <div class="description">
              <div class="field">
                <a-checkable-tag
                  v-for="item in trademark_children"
                  :key="item.code"
                  style="cursor: pointer"
                  class="category_width_son"
                  :checked="goods_checked.indexOf(item.code) > -1"
                  @change="(e) => on_field_mutli_change(e, 'goods', item.code)"
                >
                  <a-tooltip>
                    <template slot="title">
                      {{ item.name }}
                    </template>
                    {{ item.code }}
                  </a-tooltip>
                </a-checkable-tag>
                <a-input
                  :class="{ fill: !!form.serviceName }"
                  style="width:150px;display:inline-block;"
                  placeholder="搜索子类名称"
                  v-model="form.serviceName"
                ></a-input>
              </div>
              <div class="extra">
                <a-switch
                  checked-children="多选"
                  un-checked-children="单选"
                  @change="(e) => on_search_choice(e, 'goods')"
                />
              </div>
            </div>
          </a-descriptions-item>


          <a-descriptions-item label="商标类型">
            <div class="description">
              <div class="item ig">
                <a-checkable-tag
                  v-for="l in char_type_array"
                  :key="l.value"
                  style="cursor: pointer"
                  @change="(e) => on_field_change(e ? l.value : '', 'char_type')"
                  :checked="form['char_type'] == l.value"
                >
                  <div :class="data_count_char_type && !l.search_count ? 'empty' : 'fill'">
                    <span class="name">{{ l.name }}</span>
                    <span class="search_count count" v-if="l.search_count">({{ l.search_count }})</span>
                  </div>
                </a-checkable-tag>
              </div>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="商标价格">
            <div class="description">
              <div class="item ig">
                <a-checkable-tag
                  v-for="price in price_array"
                  :key="price.value"
                  style="cursor: pointer"
                  @change="(e) => on_field_change(e ? price.value : '', 'price')"
                  :checked="form['price'] == price.value"
                >
                  <div :class="data_count_price && !price.search_count ? 'empty' : 'fill'">
                    <span class="name">{{ price.name }}</span>
                    <span class="search_count count" v-if="price.search_count">({{ price.search_count }})</span>
                  </div>
                </a-checkable-tag>
              </div>
              <div class="range">
                <a-input-group compact style="display: inline-block;width: 300px;">
                  <a-input
                    style=" width: 100px; "
                    placeholder="¥大于/等于"
                    :value="price_gte"
                    data-lpignore="true"
                    @change="(e) => (price_gte = e.target.value)"
                  />
                  <a-input
                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                    placeholder="~"
                    disabled
                    data-lpignore="true"
                  />
                  <a-input
                    style="width: 100px;  border-left: 0"
                    placeholder="¥小于/等于"
                    :value="price_lte"
                    data-lpignore="true"
                    @change="(e) => (price_lte = e.target.value)"
                  />
                </a-input-group>
              </div>
            </div>
          </a-descriptions-item>

          <a-descriptions-item label="商标字数">
            <div class="description">
              <div class="item ig">
                <a-checkable-tag
                  v-for="l in length_array"
                  :key="l.value"
                  style="cursor: pointer"
                  @change="(e) => on_field_change(e ? l.value : '', 'name_length')"
                  :checked="form['name_length'] == l.value"
                  data-lpignore="true"
                >
                  <div :class="data_count_name_length && !l.search_count ? 'empty' : 'fill'">
                    <span class="name">{{ l.name }}</span>
                    <span class="search_count count" v-if="l.search_count">({{ l.search_count }})</span>
                  </div>
                </a-checkable-tag>
              </div>

              <div class="range">
                <a-input-group compact style="display: inline-block;width: 300px;">
                  <a-input
                    style="width: 100px; "
                    placeholder="大于/等于"
                    :value="name_length_gte"
                    @change="(e) => (name_length_gte = e.target.value)"
                    data-lpignore="true"
                  />
                  <a-input
                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                    placeholder="~"
                    disabled
                    data-lpignore="true"
                  />
                  <a-input
                    style="width: 100px;  border-left: 0"
                    placeholder="小于/等于"
                    :value="name_length_lte"
                    @change="(e) => (name_length_lte = e.target.value)"
                    data-lpignore="true"
                  />
                </a-input-group>
              </div>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="商标名称">
            <div style="display:flex;align-items:center">
              <a-form-model-item :class="{ fill: !!form.markName }">
                <a-input
                  allowClear
                  v-model="form.markName"
                  @pressEnter="on_search"
                  data-lpignore="true"
                  style="min-width: 500px;"
                ></a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-checkbox v-model="form.is_markname_exact">
                  精确搜索
                </a-checkbox>
                <a-checkbox v-model="form.is_markname_terms">
                  查找多个（自动分隔空格）
                </a-checkbox>
              </a-form-model-item>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="更多">
            <div class="field more">
              <a-form-model-item label="申请号" :class="{ fill: !!form.applyNo }">
                <a-input allowClear v-model="form.applyNo" @pressEnter="on_search" data-lpignore="true"></a-input>
              </a-form-model-item>

              <!-- <a-form-model-item label="初审公告期号">
                  <a-input allowClear v-model="form.exampubNo" @pressEnter="on_search"></a-input>
              </a-form-model-item> -->

              <a-form-model-item label="申请主体" :class="{ fill: !!form.applyName }">
                <a-input allowClear v-model="form.applyName" @pressEnter="on_search" data-lpignore="true"></a-input>
              </a-form-model-item>

              <!-- <a-form-model-item label="代理机构">
                  <a-input allowClear v-model="form.agentName" @pressEnter="on_search"></a-input>
              </a-form-model-item> -->
              <a-form-model-item label="商标描述" :class="{ fill: !!form.markDescriptions }">
                <a-input allowClear v-model="form.markDescriptions" @pressEnter="on_search"
                         data-lpignore="true"></a-input>
              </a-form-model-item>
              <a-form-model-item label="平台备注" :class="{ fill: !!form.remark }">
                <a-input allowClear v-model="form.remark" @pressEnter="on_search" data-lpignore="true"></a-input>
              </a-form-model-item>
              <a-form-model-item label="商标状态" :class="{ fill: !!form.tradestatus }">
                <a-select v-model="form.tradestatus" @change="(value) => on_field_change(value, 'tradestatus')" allowClear>
                  <a-select-option value="已初审">已初审</a-select-option>
                  <a-select-option value="已注册">已注册</a-select-option>
                  <a-select-option value="已转让">已转让</a-select-option>
                  <a-select-option value="已暂停">已暂停</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
          </a-descriptions-item>
        </a-descriptions>

        <div class="action">
          <div class="left">
            <a-button type="primary" @click="on_search" icon="search">
              搜索
            </a-button>

            <a-button @click="on_reset" icon="rollback">重置</a-button>


            <a-badge class="item" :count="data_list_items.length" :offset="[-12, 1]">
              <a-button style="margin-right: 12px;" class="item" icon="heart" @click="visible_list = true">
                收藏
              </a-button>
            </a-badge
            >

            <a-dropdown class="item" :disabled="!selected_rows.length">
              <a-menu slot="overlay">
                <a-menu-item @click="on_supplier_edit">
                  <a-icon type="user" />
                  批量修改供应商
                </a-menu-item>
                <a-menu-item @click="on_price_edit">
                  <a-icon type="pay-circle" />
                  批量修改价格
                </a-menu-item>
                <a-menu-item @click="on_move_tags(selected_rows)">
                  <a-icon type="tags" />
                  批量编辑标签
                </a-menu-item>
              </a-menu>
              <a-button>操作
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </div>
          <div class="right">
            <a-dropdown-button class="item" @click="on_dir_change" :getPopupContainer="(trigger) => trigger.parentNode">
              {{ sort_dir == "desc" ? "倒序" : "正序" }}：{{ sort_field_text }}
              <a-menu slot="overlay">
                <template v-for="item in sort_field_columns">
                  <a-menu-item :key="item.value" @click="on_sort_change(item.value)" v-if="sort_field != item.value">{{
                      item.name
                    }}
                  </a-menu-item>
                </template>
              </a-menu>

              <a-icon :type="sort_dir === 'asc' ? 'sort-ascending' : 'sort-descending'" slot="icon" />
            </a-dropdown-button>

            <div class="item">
              <a-switch
                :checked="!!form.db_whole"
                checked-children="全部"
                un-checked-children="有价"
                @change="(e) => on_whole_change(Number(e))"
              />

            </div>
          </div>
        </div>
      </a-form-model>

      <div class="jsd">
        <div class="count" v-if="!loading && pagination">
          检索到 <span style="font-weight: bold;color: #f44336;">{{ pagination.total || 0 }}</span> 条结果<span
          v-if="data_type == 'aggs_group'"
        >（注意：多类目检索最多只显示相关度前1000的同名商标，已过滤不满足条件的数据）</span
        >
        </div>
      </div>

      <template v-if="data_source.length || loading">
        <a-spin tip="加载中..." :spinning="loading">
          <div class="grid" style="padding:16px">
            <a-row :gutter="16">
              <template v-for="item in data_source">
                <a-col :key="item._id" :xs="24" :sm="12" :md="8" :lg="6" :xl="4" :xxl="3" style="padding-bottom: 16px;">
                  <a-card hoverable class="card" size="small" @click="on_show(item)">

                    <div class="cover" slot="cover">

<!--                      分类-->
                      <a class="namesakefenlei">
                        {{ item.internationalGroup }}类
                      </a>

                      <a
                        @click="(e) => e.stopPropagation()"
                        v-if="item._namesake_count"
                        class="namesake"
                        target="_blank"
                        :href="
                                                    `/trademark/whole?markName=${
                                                        item.markName
                                                    }&is_markname_exact=1&db_whole=${form.db_whole || 0}`
                                                "
                      >
                        {{ item._namesake_count }}
                      </a>
                      <img
                        v-lazy="item.logo_primary || item.logo"
                        onerror="this.src='https://scxm.oss-cn-hangzhou.aliyuncs.com/assets/images/img_missing.png'"
                      />
                    </div>
                    <a-card-meta>
                      <div slot="title" @click="(e) => e.stopPropagation()">
                        <div class="apply_no" @click="do_copy(item.applyNo)">NO：{{ item.applyNo }}</div>
                        <div class="title">
                          {{ item.markName }}
                          <a class="xiangm">
                            {{ item.goods ? item.goods.length : 0 }}项
                          </a>
                        </div>
<!--                        <div class="description">
                          <a-tooltip>
                            <template slot="title">
                              {{ item.goods_text }}
                            </template>
                            <div class="goods" v-if="item.goods_text">
                              {{ item.goods_text }}
                            </div>
                          </a-tooltip>
                        </div>-->
                      </div>
<!--                      <template slot="description">
                        <div class="description">
                          <a-tooltip>
                            <template slot="title">
                              {{ item.goods_text }}
                            </template>
                            <div class="goods" v-if="item.goods_text">
                              {{ item.goods_text }}
                            </div>
                          </a-tooltip>
                        </div>
                      </template>-->
                    </a-card-meta>
                    <div class="extra">
                      <div :class="item.price || 'none'" class="price">
                        <small>¥</small>{{ item.price || "无价格" }}
                      </div>


<!--                      <span style="font-size: 12px;color: gray;padding-top:4px;">
                              {{'['+item.tradestatus+']'}}
                            </span>-->

                      <div :class="item.sell_price || 'none'" class="sell_price">
                        <span style="margin-right: 10px;" v-if="item.preview && item.preview.length">
                          <small>效果图</small>{{  item.preview.length }}张
                        </span>

<!--                        <small>售¥</small>{{ item.sell_price || "无价格" }}-->
                        <span v-if="item.tradestatus === '已注册'">{{'['+item.tradestatus+']'}}</span>
                        <span v-else style="color: red">{{'['+item.tradestatus+']'}}</span>
                      </div>

<!--                      <div :class="item.sell_price || 'none'" class="sell_price">
                        <small>售¥</small>{{ item.sell_price || "无价格" }}
                        <a-tag color="blue">{{item.enquiry_count}}次</a-tag>
                      </div>-->
                    </div>

                    <div class="extra-action">
                      <div class="btns">
                        <div class="edit" @click="(e) => on_edit(e, item)">
                          <a-icon type="edit" />
                        </div>

                        <div
                          class="download"
                          @click="(e) => download_pic(e, item.logo_primary || item.logo, item.applyNo)"
                        >
                          <a-tooltip :title="item.lock_time? '询价结束日期'+item.lock_time : null">
                            <a-icon v-if="item.lock_time" style="color: red" type="lock" />
                            <a-icon v-else="item.lock_time" type="lock" />
                          </a-tooltip>

                        </div>

                        <div class="collect" @click="(e) => on_add_item(e, item)">
                          <a-icon type="heart" />
                        </div>


<!--                        询价按钮-->
                        <div
                            class="enquiry"
                            @click="(e) => on_enquiry(e, item)"
                            v-if="item.suppliers && item.suppliers.length"
                        >
                          <a-icon type="transaction" />
                        </div>
                        <!--询价按钮-->
<!--                        <div
                          class="enquiry"
                          @click="(e) => on_enquiry(e, item)"
                          v-if="item.suppliers && item.suppliers.length && item.lock_time == null"
                        >
                          <a-icon type="transaction" />
                        </div>-->

                        <!--锁定期询价按钮-->
<!--                        <div
                            class="enquiry"
                            v-if="item.lock_time">
                          <a-tooltip :title="'询价结束日期'+item.lock_time">
                            <a-icon type="transaction" />
                          </a-tooltip>
                        </div>-->
                      </div>
                    </div>
                  </a-card>
                </a-col>

              </template>
            </a-row>
          </div>
        </a-spin>
      </template>

      <a-empty :image="simpleImage" v-else>
        <a-button @click="load" icon="reload" style="margin-right:24px;">
          刷新
        </a-button>
        <a-button @click="on_reset" icon="rollback">重置</a-button>
      </a-empty>

      <div class="load-more" v-if="data_source.length && pagination && pagination.current < pagination.lastPage">
        <a-button icon="arrow-down" @click="load_more" :loading="loading_more" :disabled="loading_more">
          加载更多
        </a-button>
      </div>

      <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
        <div class="tips">
          出于搜索性能原因，商标数据最多展示前9999条数据。
        </div>
        <a-pagination
          :disabled="loading"
          v-model="pagination.current"
          :total="pagination.total"
          :page-size.sync="pagination.pageSize"
          show-size-changer
          showQuickJumper
          :pageSizeOptions="['20', '50', '100', '200']"
          @change="(page, pageSize) => {
                        on_pagination_change_common(page, pageSize);
                    }"
          :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
        />
      </div>
    </div>
    <!-- 修改 -->
    <modal_edit :visible="visible_edit" @close="visible_edit = false" :record="selected_record"
                :callback="edit_callback" />

    <!--  询价 -->
    <modal_enquiry :visible="visible_enquiry" @close="visible_enquiry = false" :record="selected_record"
                :callback="edit_callback" />

<!--    释义-->
    <modal_paraphrase :visible="visible_paraphrase" @close="visible_paraphrase = false" :record="selected_record"
                   :callback="load" />

    <!-- 批量修改供应商 -->
    <modal_supplier :visible="visible_supplier_edit" @close="visible_supplier_edit = false" :record="selected_rows"
                    :callback="load" />

    <!-- 批量修改价格 -->
    <modal_price :visible="visible_price_edit" @close="visible_price_edit = false" :record="selected_rows"
                 :callback="load" />

    <!-- 供应商详情 -->
    <a-drawer
      title="供应商列表"
      placement="right"
      :closable="false"
      :visible="visible_supplier_show"
      @close="visible_supplier_show = false"
      width="600"
    >
      <a-table
        size="small"
        :columns="supplier_column"
        :data-source="data_supplier"
        :pagination="false"
        key="id"
        :loading="loading_supplier"
      >
      </a-table>
    </a-drawer>

    <a-drawer title="商标详情" placement="right" :closable="false" :visible="visible_show" @close="visible_show = false"
              width="800">
      <a-descriptions title="商标信息" v-if="selected_record" :column="2">
        <a-descriptions-item label="商标名称"> {{ selected_record.markName }}</a-descriptions-item>
        <a-descriptions-item label="商标注册号"> {{ selected_record.applyNo }}</a-descriptions-item>
        <a-descriptions-item label="商标分类" :span="2"> {{ selected_record.internationalGroup }}类</a-descriptions-item>
        <a-descriptions-item label="子分类" :span="2">
          {{ selected_record.goods && selected_record.goods.map((v) => "【" + v.strSameGroup + "】" + v.serviceName).join("，")
          }}
        </a-descriptions-item>

        <a-descriptions-item label="法律状态">
          <span style="border: 2px solid red;padding: 2px;">{{ selected_record.tradestatus }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="申请主体">
          {{ selected_record.applyName }}
        </a-descriptions-item>
        <a-descriptions-item label="代理机构">
          {{ selected_record.agentName }}
        </a-descriptions-item>
        <a-descriptions-item label="申请日期">
          {{ moment(selected_record.applyDate).format("YYYY-MM-DD") }}
        </a-descriptions-item>
        <a-descriptions-item label="价格">
          {{ selected_record.price }}
        </a-descriptions-item>
        <a-descriptions-item label="评分">
          <a-rate :default-value="selected_record.score" disabled />
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">
          {{ selected_record.remark || "-" }}
        </a-descriptions-item>
        <a-descriptions-item label="公告">
          <a v-for="(link, lIdx) in selected_record.gonggaos" :key="lIdx" :href="link.url" target="_blank">{{ link.ggName }}</a>
        </a-descriptions-item>

        <a-descriptions-item label="商标释义" :span="2">
          <div class="edit" @click="(e) => on_paraphrase(selected_record)" style="cursor: pointer">
            <a-icon type="edit" style="margin-right: 10px;color: #3874cf" />{{ selected_record.paraphrase || "" }}
          </div>
        </a-descriptions-item>
      </a-descriptions>

      <a-divider />

      <template v-if="typeof selected_record.preview === 'object' && Array.isArray(selected_record.preview) && selected_record.preview.length > 0 ">

        <a-divider orientation="left">效果图</a-divider>
        <a-row :gutter="16" >
          <a-col class="gutter-row" :span="6"  v-for="(link,lll) in selected_record.preview">
            <div class="gutter-box">
              <img :src="link" style="width: 200px;">
            </div>
          </a-col>
        </a-row>

<!--        <a-carousel style="height: 200px;">
          <div v-for="(link,lll) in selected_record.preview">
            <h3>
              效果图-{{lll +1}}
              <img :src="link" style="width: 200px;">
            </h3>
          </div>
        </a-carousel>-->
      </template>

      <a-divider />

      <template v-if="selected_record">
        <a-table :dataSource="selected_record.enquiry" :columns="columns">
          <template #title><span  style="font-weight: bold; font-size: 16px; color: black;">询价记录</span></template>
          <template slot="created_at" slot-scope="text, record">
            {{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}
          </template>
          <template slot="lock_time">
            {{ selected_record.lock_time ?? null }}
          </template>
        </a-table>
      </template>

      <a-divider />
      <template v-if="selected_record">
        <a-table :dataSource="selected_record.revisit" :columns="columns_revisit">
          <template #title><span  style="font-weight: bold; font-size: 16px; color: black;">跟进记录</span></template>
          <template slot="created_at" slot-scope="text, record">
            {{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}
          </template>
        </a-table>
      </template>

    </a-drawer>

    <!-- 标签 -->
    <modal_tag_list />

    <!-- 清单 -->
    <a-drawer
      :width="460"
      :title="`商标收藏（${data_list_items.length}）`"
      placement="right"
      :closable="false"
      :visible="visible_list"
      @close="visible_list = false"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <a-button block icon="close" @click="on_empty_list" :disabled="!data_list_items.length">
            清空
          </a-button>
        </a-col>
        <a-col :span="12">
          <a-button block icon="export" @click="export_list_item" :disabled="!data_list_items.length">
            导出
          </a-button>
        </a-col>
      </a-row>

      <a-list item-layout="horizontal" :data-source="data_list_items" class="res-list">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <a class="title" slot="title" @click="on_show(item)">{{ item.markName }}</a>

            <div slot="avatar" style="border: 1px solid #f0f0f0;">
              <img
                style="width:100px;height:100px"
                v-lazy="item.logo_primary || item.logo"
                onerror="this.src='https://scxm.oss-cn-hangzhou.aliyuncs.com/assets/images/img_missing.png'"
              />
            </div>

            <div class="desc" slot="description">
              <div class="">注册号：{{ item.applyNo }}</div>
              <div class="">【{{ item.internationalGroup }}类】{{ item.type_text }}</div>
              <div class="">¥ {{ item.price || "无价格" }}</div>
            </div>
          </a-list-item-meta>
          <div>
            <!-- <a-button
                size="small"
                shape="circle"
                icon="icon icon-link1"
                @click="redirect(item.release_url)"
                style="margin-right:12px;"
            >
            </a-button
            > -->
            <a-button size="small" shape="circle" icon="close" @click="on_remove_items(item)"></a-button>
          </div>
        </a-list-item>
      </a-list>
    </a-drawer>
  </div>
</template>
<script>
import moment from "moment";
import common_pagination from "../../../mixins/common_pagination.js";
import modal_edit from "./modal_edit";
import modal_enquiry from "./modal_enquiry";
import modal_paraphrase from "./modal_paraphrase";
import modal_supplier from "./modal_supplier";
import modal_price from "./modal_price";
import trademark_data from "../../../data/trademark.json";
import modal_tag_list from "../components/modal_tag_list";
import { Empty } from "ant-design-vue";

let init_form = {
  internationalGroup: "",
  goods: "",
  price: null,
  name_length: null,
  serviceName: null,
  is_markname_exact: false,
  is_markname_terms: false,
  char_type: null,
  score: null,
  db_whole: 0
};
export default {
  mixins: [common_pagination],
  components: { modal_edit,modal_enquiry,modal_paraphrase, modal_supplier, modal_price, modal_tag_list },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  data() {
    return {
      path: "/trademark/whole",
      form: {},
      trademark_data: trademark_data,
      trademark_children: [],
      internationalGroup_checked: [],
      goods_checked: [],
      visible_search: true,
      visible_edit: false,
      visible_enquiry: false,
      visible_paraphrase: false,
      visible_supplier_edit: false,
      visible_price_edit: false,
      selected_record: {
        preview:[]
      },
      visible_supplier_show: false,
      visible_show: false,
      date_range: [moment().startOf("month"), moment().endOf("month")],
      range_date: {
        今天: [moment(), moment()],
        昨天: [moment(new Date()).add(-1, "days"), moment(new Date()).add(-1, "days")],
        本周: [moment().startOf("week"), moment().endOf("week")],
        本月: [moment().startOf("month"), moment().endOf("month")]
      },
      sort_field: "applyDate",
      sort_dir: "desc",
      sort_field_text: "申请时间",
      price_gte: "",
      price_lte: "",
      name_length_lte: "",
      name_length_gte: "",
      loading_tag: false,
      data_list_items: [],
      visible_list: false,
      data_type: "",
      sort_field_columns: [
        { name: "申请时间", value: "applyDate" },
        { name: "注册时间", value: "registerDate" },
        { name: "初审公告日期", value: "exampubDate" },
        { name: "商标价格", value: "price" },
        { name: "商标字数", value: "name_length" },
        { name: "评分", value: "score" }
      ],
      price_array: [
        { name: "5百以下", value: "0,500" },
        { name: "5百-1千", value: "500,1000" },
        { name: "1千-2千", value: "1000,2000" },
        { name: "2千-5千", value: "2000,5000" },
        { name: "5千-1万", value: "5000,10000" },
        { name: "1万-5万", value: "10000,50000" },
        { name: "5万以上", value: "50000," }
      ],
      length_array: [
        { name: "1个字", value: "1" },
        { name: "2个字", value: "2" },
        { name: "3个字", value: "3" },
        { name: "4个字", value: "4" },
        { name: "5个字", value: "5" },
        // { name: "5个字以下", value: ",5" },
        { name: "5个字以上", value: "5," }
      ],
      char_type_array: [
        { name: "图形", value: "1" },
        { name: "纯数字", value: "7" },
        { name: "纯中文", value: "6" },
        { name: "纯英文", value: "8" },
        { name: "中文+数字", value: "3" },
        { name: "中文+英文", value: "4" },
        { name: "数字+英文", value: "5" },
        { name: "中文+数字+英文", value: "2" }
      ],

      supplier_column: [
        { title: "价格", dataIndex: "price", width: 100 },
        {
          title: "供应商",
          dataIndex: "supplier",
          customRender: (e) => e.contact_name + "（" + e.company + "）",
          width: 300
        },
        { title: "录入者", dataIndex: "user.name", width: 120 },
        {
          title: "录入时间",
          dataIndex: "created_at",
          customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD") : ""),
          width: 120
        },
        { title: "备注", dataIndex: "remark" }
      ],
      data_source: [],
      data_supplier: [],
      loading: false,
      loading_supplier: false,
      internationalGroup_choice: false,
      goods_choice: false,
      data_count_internationalGroup: null,
      data_count_char_type: null,
      data_count_price: null,
      data_count_name_length: null,
      edit_callback: null,
      loading_more: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'member.id',
          key: 'member.id',
        },
        {
          title: '姓名',
          dataIndex: 'member.name',
          key: 'member.name',
        },
        {
          title: '公司',
          dataIndex: 'member.com_name',
          key: 'member.com_name',
        },
        {
          title: '销售',
          dataIndex: 'user.name',
          key: 'user.name',
        },
        {
          title: '报价',
          dataIndex: 'sell_price',
          key: 'sell_price',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
        },
        {
          title: '报价时间',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: "created_at",
          },
        },
        {
          title: '到期时间',
          dataIndex: 'lock_time',
          key: 'lock_time',
          scopedSlots: {
            customRender: "lock_time",
          }
        }
      ],
      columns_revisit: [
        {
          title: '跟进时间',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: "created_at",
          },
        },
        {
          title: '跟进内容',
          dataIndex: 'content',
          key: 'content',
        }
      ],
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
    this.reset_query();

    //标签
    this.load_tags();

    //收藏
    this.load_list_item();

    if (Object.keys(this.$route.query).length) {
      this.load();
    }

    this.load();


    //键盘事件
  },
  watch: {
    $route() {
      this.load();
      this.reset_query();
    },
    "form.price"(e) {
      if (e) {
        let r = e.split(",");
        this.price_gte = r[0];
        this.price_lte = r[1];
      } else {
        this.price_gte = "";
        this.price_lte = "";
      }
    },
    "form.name_length"(e) {
      if (e) {
        let r = e.split(",");
        if (r.length == 2) {
          this.name_length_gte = r[0];
          this.name_length_lte = r[1];
        }
      } else {
        this.name_length_gte = "";
        this.name_length_lte = "";
      }
    },
    name_length_gte(e) {
      if (e) {
        this.form.name_length = e + "," + this.name_length_lte;
      }
    },
    name_length_lte(e) {
      if (e) {
        this.form.name_length = this.name_length_gte + "," + e;
      }
    },
    price_gte(e) {
      if (e) {
        this.form.price = e + "," + this.price_lte;
      }
    },
    price_lte(e) {
      if (e) {
        this.form.price = this.price_gte + "," + e;
      }
    },
    "form.internationalGroup"(e) {
      this.internationalGroup_checked = [];

      if (e) {
        this.internationalGroup_checked = e.split("|");

        let index = trademark_data.findIndex((v) => v.code == e);
        if (index > -1) {
          this.trademark_children = trademark_data[index]["children"];

          return true;
        }
      }
      this.trademark_children = [];
    },
    "form.goods"(e) {
      this.goods_checked = [];
      if (e) {
        this.goods_checked = e.split("|");
      }
    }
  },
  computed: {
    year_array() {
      return new Array(2022 - 1999)
        .fill(1999)
        .map((el, i) => 1999 + i)
        .reverse();
    }
  },
  methods: {
    moment,
    reset_query() {
      const query = this.$route.query;
      if ("date_range" in query) {
        const arr = query["date_range"].split(",");
        if (arr.length == 2) {
          this.date_range = [arr[0] ? moment(arr[0]) : null, arr[1] ? moment(arr[1]) : null];
        }
      }

      if ("sort_field" in query) {
        this.sort_field = query["sort_field"];
        let index = this.sort_field_columns.findIndex((v) => v.value == this.sort_field);

        if (index > -1) {
          this.sort_field_text = this.sort_field_columns[index]["name"];
        }
      }
      if ("sort_dir" in query) {
        this.sort_dir = query["sort_dir"];
      }

      if ("db_whole" in query) {
        query["db_whole"] = Number(query["db_whole"]);
      }

      if ("is_markname_exact" in query) {
        query["is_markname_exact"] = query["is_markname_exact"] == "1" || query["is_markname_exact"] == "true";
      }

      if ("is_markname_terms" in query) {
        query["is_markname_terms"] = query["is_markname_terms"] == "1" || query["is_markname_terms"] == "true";
      }

      this.$set(this, "form", query);
    },
    load() {

      if(this.selected_record && this.selected_record.id){
        this.on_show(this.selected_record);
      }

      this.loading = true;
      let new_query = JSON.parse(JSON.stringify(this.$route.query));

      this.$http
        .get(`/trademark/whole?${this.objectToQuery(new_query)}`)
        .then((res) => {
          if (res.success) {
            res.data = this.map_res_data(res.data);

            this.data_source = res.data;
            this.pagination = res.pagination
              ? {
                pageSize: res.pagination.per_page,
                total: res.pagination.total,
                current: res.pagination.current_page,
                lastPage: res.pagination.last_page,
                totalReality: res.pagination.total_reality
              }
              : null;
            this.data_type = res.type || "";
            //自动滚动
            if (this.pagination.current != 1) document.getElementsByClassName("grid")[0].scrollIntoView();
            this.ready_get_namesake(res.data);
          } else {
            this.$error({ title: "加载数据异常（复制该信息给管理员）", content: res.message, centered: true });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false;
        });
      //this.load_count();
    },
    load_more() {
      this.loading_more = true;
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["page"] = this.pagination.current + 1;
      this.$http
        .get(`/trademark/whole?${this.objectToQuery(new_query)}`)
        .then((res) => {
          if (res.success) {
            res.data = this.map_res_data(res.data);
            this.data_source = this.data_source.concat(res.data);
            this.pagination = res.pagination
              ? {
                pageSize: res.pagination.per_page,
                total: res.pagination.total,
                current: res.pagination.current_page,
                lastPage: res.pagination.last_page,
                totalReality: res.pagination.total_reality
              }
              : null;
            this.data_type = res.type || "";

            this.ready_get_namesake(res.data);
          } else {
            this.$error({ title: "加载数据异常（复制该信息给管理员）", content: res.message, centered: true });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading_more = false;
        });
    },
    /**
     * 处理res.data里的数据
     */
    map_res_data(data) {
      return data.map((v) => {
        //处理goods的text
        if (v.goods) {
          v.goods_text = v.goods.map((vv) => vv.serviceName).join(",");
        }
        return v;
      });
    },
    /**
     * 准备获取同名商标数量
     */
    ready_get_namesake(data) {
      //获取同名的商标
      let markNames = data.map((v) => v.markName);

      //分割成2个数组
      this.sliceArray([...new Set(markNames)], 50).map((v) => {
        this.get_namesake_count(v);
      });
    },
    /**
     * 同名的商标数量
     */
    get_namesake_count(wds) {
      this.data_namesake = null;
      let query = {};
      query["markNames"] = wds.join(",");
      this.$http
        .get(`/trademark/namesake_count?${this.objectToQuery(query)}`)
        .then((res) => {
          if (res.success) {
            this.data_namesake = res.data;
            let data = JSON.parse(JSON.stringify(this.data_source));
            data.map((v) => {
              if (!("_namesake_count" in v)) {
                if (v.markName in res.data) {
                  v._namesake_count = res.data[v.markName] > 1 ? res.data[v.markName] : 0;
                }
              }
              return v;
            });
            this.data_source = data;
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    load_count() {
      this.data_count_internationalGroup = null;
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      this.$http
        .get(`/trademark/query_counter?${this.objectToQuery(new_query)}`)
        .then((res) => {
          if (res.success) {
            this.data_count_internationalGroup = res.data["internationalGroup"];
            this.data_count_char_type = res.data["char_type"];
            this.data_count_price = res.data["price"];
            this.data_count_name_length = res.data["name_length"];

            this.trademark_data.forEach((data) => {
              let count_data = [];
              count_data = this.data_count_internationalGroup.find((cd) => cd.value == data.code);
              if (count_data) data["search_count"] = count_data.count;
              else data["search_count"] = 0;
            });
            this.char_type_array.forEach((data) => {
              let count_data = [];
              count_data = this.data_count_char_type.find((cd) => cd.value == data.value);
              if (count_data) data["search_count"] = count_data.count;
              else data["search_count"] = 0;
            });
            this.price_array.forEach((data) => {
              let count_data = [];
              count_data = this.data_count_price.find((cd) => cd.value == data.value);
              if (count_data) data["search_count"] = count_data.count;
              else data["search_count"] = 0;
            });
            this.length_array.forEach((data) => {
              let count_data = [];
              count_data = this.data_count_name_length.find((cd) => cd.value == data.value);
              if (count_data) data["search_count"] = count_data.count;
              else data["search_count"] = 0;
            });

            //重新组合
            // this.data_count_internationalGroup.map((v) => {
            //     this.trademark_data.find((td) => td.code == v.value)["search_count"] = v.count;
            // });
            // this.data_count_char_type.map((v) => {
            //     this.char_type_array.find((ca) => ca.value == v.value)["search_count"] = v.count;
            // });
            // this.data_count_price.map((v) => {
            //     this.price_array.find((ca) => ca.value == v.value)["search_count"] = v.count;
            // });
            // this.data_count_name_length.map((v) => {
            //     this.length_array.find((ca) => ca.value == v.value)["search_count"] = v.count;
            // });
          }
        })
        .catch((e) => {
        })
        .then(() => {
        });
    },
    find_count(code) {
      let f = this.data_count_internationalGroup.find((v) => v.value == code);

      return f ? f["count"] : null;
    },
    load_tags() {
      this.loading_tag = true;
      this.$http
        .get("trademark/tags")
        .then((response) => {
          if (response.success) {
            this.$store.commit("change_state", { name: "trademark_tags", value: response.data });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading_tag = false;
        });
    },
    on_date_change(e) {
      this.date_range = e;
      const value = [e[0].format("YYYY-MM-DD 00:00:00"), e[1].format("YYYY-MM-DD 23:59:59")];
      this.on_field_change(value.join(","), "date_range");
    },
    on_search() {
      const query = JSON.parse(JSON.stringify(this.form));

      const checked = [];
      Object.keys(query).map((v) => {
        query[v] = checked.indexOf(v) > -1 ? Number(query[v]) : query[v];
      });

      query["_t"] = +new Date();
      query["_s"] = 1;
      query["page"] = 1;

      this.$router.push(this.path + "?" + this.objectToQuery(query));
    },
    on_reset() {
      this.$router.replace(this.path);
    },
    on_dir_change() {
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["sort_dir"] = this.sort_dir === "asc" ? "desc" : "asc";

      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_sort_change(e) {
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["sort_field"] = e;

      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_field_change(value, field) {
      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query[field] = value;
      new_query["_s"] = 1;
      new_query["_t"] = +new Date();
      new_query["page"] = 1;
      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_whole_change(e) {
      this.form.db_whole = !!e;

      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      new_query["db_whole"] = e;
      new_query["_s"] = 1;
      new_query["page"] = 1;

      this.$router.push(this.path + "?" + this.objectToQuery(new_query));
    },
    on_field_mutli_change(e, field, value) {
      //当主分类改动时，goods清空
      if (field === "internationalGroup") {
        this.form.goods = "";
      }

      //单选
      if (field === "internationalGroup" && !this.internationalGroup_choice) {
        this.on_field_change(value, field);
        return false;
      }

      //单选
      if (field === "goods" && !this.goods_choice) {
        this.on_field_change(value, field);
        return false;
      }

      if (e) {
        if (this.form[field]) {
          var vv = [...this.form[field].split("|"), value].join("|");
        } else {
          var vv = value;
        }
      } else {
        let arr = this.form[field].split("|");
        arr.splice(
          this.form[field].split("|").findIndex((v) => v == value),
          1
        );

        var vv = arr.length ? arr.join("|") : null;
      }

      //this.$set(this.form, field, vv ? vv.toString() : vv);
      this.on_field_change(vv ? vv.toString() : vv, field);
    },
    trademark_text(v) {
      let t_array = this.trademark_array;
      let index = t_array.findIndex((e) => e.value == v);
      if (index > -1) {
        return "【" + t_array[index]["value"] + "】" + t_array[index]["name"];
      }
    },
    on_edit(e, record) {
      e.stopPropagation();

      this.selected_record = record;
      this.visible_edit = true;

      this.edit_callback = (e) => {
        Object.keys(e).map((v) => {
          if (Object.prototype.hasOwnProperty.call(record, v)) {
            record[v] = e[v];
          }
        });
      };
    },
    on_supplier_edit() {
      this.visible_supplier_edit = true;
    },
    on_price_edit() {
      this.visible_price_edit = true;
    },
    on_supplier_show(record) {
      this.visible_supplier_show = true;
      this.selected_record = record;
      this.load_supplier(record.applyNo);
    },
    load_supplier(apply_no) {
      this.loading_supplier = true;
      this.$http
        .get(`/trademark/${apply_no}/supplier`)
        .then((res) => {
          if (res.success) {
            this.data_supplier = res.data;
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading_supplier = false;
        });
    },
    on_export() {
      this.$confirm({
        centered: true,
        title: "是否导出选中商标？",
        loading: true,
        onOk: () => {
          return new Promise((resolve) => {
            this.$http
              .post("/trademark/export", { apply_nos: this.selected_rows.map((v) => v.applyNo) })
              .then((res) => {
                if (res.success) {
                  window.location.href = res.url;
                } else {
                  this.$error({ title: "失败", content: res.message, centered: true });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          }).catch();
        }
      });
    },
    on_move_tags(item) {
      this.$event_bus.$emit("trademark_tags_list", item, () => {
        this.load_tags();
        this.load();
        this.selected_row_keys = [];
      });
    },
    on_show(record) {
      this.selected_record = record;
      this.$http
        .post("/trademark/refresh", { apply_no: record.applyNo, internationalGroup: record.internationalGroup })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.selected_record.gonggaos = res.data.gonggaos;
            this.selected_record.revisit = res.data.revisit;
            this.selected_record.enquiry = res.data.enquiry;
            this.selected_record.preview = res.data.preview;
            this.selected_record.paraphrase = res.data.paraphrase;
            this.visible_show = true;
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    on_card_checkbox(e, item) {
    },
    on_search_choice(e, field) {
      this[field + "_choice"] = e;
      if (field === "internationalGroup") {
      }
    },
    on_add_item(e, record) {
      e.stopPropagation();
      this.$http
        .post("/trademark/list/add_to_list", { apply_no: record.applyNo })
        .then((res) => {
          if (res.success) {
            record.list_items_count = 1;
            this.load_list_item();
            this.$message.success("加入收藏成功");
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    on_remove_items(record) {
      this.$http
        .delete("/trademark/list/item/" + record.applyNo)
        .then((res) => {
          if (res.success) {
            //todo:无需重复加载
            this.load_list_item();

            const i = this.data_source.findIndex((v) => v.apply_no == record.applyNo);
            if (i > -1) {
              this.$set(this.data_source[i], "list_items_count", 0);
            }
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    on_empty_list() {
      var old_list_data = JSON.parse(JSON.stringify(this.data_list_items));
      this.$http
        .delete("/trademark/list/empty_items")
        .then((res) => {
          if (res.success) {
            this.data_list_items = [];
            old_list_data.map((ov) => {
              const i = this.data_source.findIndex((v) => v.apply_no == ov.applyNo);
              if (i > -1) {
                this.$set(this.data_source[i], "list_items_count", 0);
              }
            });
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    load_list_item() {
      this.$http
        .get("/trademark/list/items")
        .then((res) => {
          if (res.success) {
            this.data_list_items = res.data;
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    export_list_item() {
      this.$http
        .post("/trademark/list/export")
        .then((res) => {
          if (res.success) {
            window.location.href = res.url;
          } else {
            this.$error({ title: "失败", content: res.message, centered: true });
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    },
    on_paraphrase(item){
      this.selected_record = item;
      this.visible_paraphrase = true;
    },
    on_enquiry(e, item) {
      e.stopPropagation();

      this.selected_record = item;
      this.visible_enquiry = true;


      /*this.$confirm({
        centered: true,
        title: "是否对该商标发起询价？",
        loading: true,
        onOk: () => {
          return new Promise((resolve) => {
            this.$http
              .post("/trademark/enquiry", { apply_no: item.applyNo })
              .then((res) => {
                if (res.success) {
                  this.$message.success(res.message);
                } else {
                  this.$error({ title: "失败", content: res.message, centered: true });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          }).catch();
        }
      });*/
    }
  }
};
</script>
<style lang="less" scoped>
.framework-body {
  .ant-tag {
    font-size: 14px;
  }

  .main {
    overflow-y: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .jsd {
      padding: 4px 12px;
    }

    .search {
      padding: 12px;
      position: relative;

      .hide-search {
        width: 100%;
        height: 5px;
        background: #f0f0f0;
        margin-bottom: 12px;
      }

      .toggle {
        position: absolute;
        position: absolute;
        bottom: 40px;
        left: 50%;
        margin-left: -16px;
      }

      // background-color: #f0f8ff;
      .fill {
        /deep/ .ant-input,
        /deep/ .ant-select-selection,
        &.ant-input {
          background: #e3f2fd;
        }
      }

      .more {
        /deep/ .ant-form-item-label {
          width: 80px;
        }

        /deep/ .ant-form-item-control-wrapper {
          width: 180px;
        }
      }

      .description {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .range {
          text-align: right;
        }

        .search_count {
          font-size: 12px;
          color: #9e9e9e;
        }

        .item {
          min-width: 580px;
        }

        .ig {
          .empty {
            opacity: 0.2;

            .count {
              color: #9e9e9e;
            }
          }

          .code {
            color: #9e9e9e;
            margin-right: 4px;
            font-size: 12px;
          }

          .name {
            margin-right: 4px;
          }
        }

        .field {
          width: 100%;
        }

        .extra {
          flex: 1;
          flex-basis: 70px;
        }
      }

      .action {
        display: flex;
        justify-content: space-between;

        .ant-btn {
          margin-right: 12px;

          &:last-child {
            margin-right: 0;
          }
        }

        .right {
          display: flex;
          align-items: center;

          .item {
            margin-right: 12px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .category {
        .ant-btn {
          margin-right: 12px;
        }
      }

      .ant-descriptions {
        /deep/ .ant-descriptions-item-label {
          width: 100px;
        }
      }
    }
  }

  .id {
    color: #00000080;
  }

  .h2 {
    margin-top: 32px;
    margin-left: 16px;
  }

  .hover-a {
    color: rgba(0, 0, 0, 0.65);

    &:hover {
      color: #1555c2;
    }
  }

  .load-more {
    text-align: center;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .page {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;

    .tips {
      font-size: 12px;
      color: #9e9e9e;
    }
  }

  .grid {
    min-height: 200px;

    .items {
      border-radius: 5px;
      background-color: #fafafa;
      // padding: 12px;
      .card {
        // height: auto;
        // .cover {
        //     height: 150px;
        // }
      }
    }

    .card {
      min-height: 315px;
      position: relative;
      overflow: hidden;

      /*&:hover {
        .extra-action {
          // margin-bottom: 0;
          height: 46px;
        }

        .cover {
          margin-bottom: -46px;
        }
      }*/


      /deep/ .ant-card-cover {
        overflow: hidden;
      }

      .doc-count {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 12px;
        right: 12px;
        background: #f44336;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        line-height: 30px;
        border-radius: 50%;
      }

      .apply_no {
        font-size: 12px;
        color: #aaa;
      }

      .title {
        display: flex;
        justify-content: space-between;
        letter-spacing: 2px;
      }

      .checkbox {
        position: absolute;
        left: 12px;
        top: 12px;
        z-index: 2;
      }

      .cover {
        height: 200px;
        overflow: hidden;
        position: relative;
        transition: 0.3s all;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .description {
        display: flex;
        align-items: center;

        .ing {
          width: 50px;
          flex-basis: 50px;
          border: 1px solid #000000d9;
          border-radius: 3px;
          color: #000000d9;
          margin-right: 4px;
          text-align: center;
          padding: 0 2px;

          small {
            vertical-align: text-top;
          }
        }

        .goods {
          -webkit-line-clamp: 1;
          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient: vertical;
          width: 100%;
        }
      }

      .extra {
        margin-top: 12px;

        .price {
          font-size: 16px;
          color: #ff5722;
          /*display:inline;*/
          float: left;

          &.none {
            color: #9e9e9e;
          }
        }

        .sell_price {
          /*display:inline;*/
          float: right;
          font-size: 12px;
          color: #ff5722;

          &.none {
            color: #9e9e9e;
          }
        }
      }

      .extra-action {
        // margin-bottom: -46px;
        /*clear: both;
        height: 0;
        transition: 0.3s all;
        overflow: hidden;*/
        clear: both;
        height: 20px;

        .btns {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 12px;

          .edit {
            font-size: 18px;
            cursor: pointer;
          }

          .download {
            font-size: 18px;
            cursor: pointer;
          }

          .collect {
            font-size: 18px;
            cursor: pointer;
          }

          .enquiry {
            font-size: 18px;
            cursor: pointer;
          }
        }
      }

      .action {
        position: absolute;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        height: 30px;
        display: none;
        right: 0;
        left: 0;
      }
    }
  }

  .namesake {
    position: absolute;
    margin: 0;
    top: 0;
    right: 0;
    padding: 2px 8px;
    background: #e8f4ff;
    color: #1555c2;
    border-bottom-left-radius: 5px;
  }

  .namesakefenlei {
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    padding: 2px 8px;
    background: #e8f4ff;
    color: #1555c2;
    border-bottom-left-radius: 5px;
  }

  .xiangm{
    text-decoration: none;
  }

  .category_description{
    width: 1040px !important;
  }
  .category_width{
    width: 100px !important;
  }
  .category_width_son{
    width: 40px !important;
  }

}
</style>
